import "core-js/modules/es.number.constructor.js";
import http from '@/utils/http';
export default {
  emits: ['changes'],
  props: {
    id: Number
  },
  created: function created() {
    this.fo();
  },
  data: function data() {
    return {};
  },
  methods: {
    fo: function fo() {
      var _this = this;

      console.log(this.id + 'id');
      http.get("/ksfweixinshareurlconfig/info/".concat(this.id)).then(function (res) {
        console.log(res.data, '详情');
        var _res$data = res.data,
            code = _res$data.code,
            data = _res$data.data;

        if (200 == code) {
          _this.$emit('changes', data);
        }
      });
    }
  }
};